import React from 'react';
import PropTypes from 'prop-types';
import { transformPrompt } from '../../../../../../utils';

export default function Labels({ labels }) {
  let alignment = '';
  if (labels.length === 1) {
    alignment = ' bipolar-vertical-labels--center';
  }
  return (
    <div className={`bipolar-vertical-labels${alignment}`}>
      {labels.map((label) => (
        <span
          className="bipolar-vertical-label inline-children"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: transformPrompt(label) || '&nbsp;',
          }}
        ></span>
      ))}
    </div>
  );
}

Labels.propTypes = {
  labels: PropTypes.array,
};
